/**
 * F7.6 — Redirect /app/trabajadores/:id → /app/expediente?patient=:id.
 *
 * El módulo WorkerDetail.tsx fue absorbido por el Expediente patient-centric (F7.5)
 * (ver ADR-033 + MINIMAL SURFACE).
 *
 * Mantenemos esta ruta como redirect 301 (Navigate replace) durante 30+ días para
 * no romper deep-links externos: magic-links viejos, correos, integraciones FHIR.
 */
import { Navigate, useParams } from 'react-router-dom'

export function WorkerDetailRedirect() {
  const { id } = useParams<{ id: string }>()
  if (!id) {
    return <Navigate to="/app/expediente" replace />
  }
  return <Navigate to={`/app/expediente?patient=${encodeURIComponent(id)}`} replace />
}
